<template>
  <div style="padding: 10px 14px">
    <h1>Terms of Use</h1>
    <p>
      Welcome to use our products and services! Before using them, please carefully read and agree to the following terms of use. Your continued use of our products or
      services shall be deemed as your acceptance of these terms.
    </p>

    <h2>1. Service Content</h2>
    <ol>
      <li>
        We provide you with various functions and services related to [Product Name], including but not limited to [list main functions such as online document editing, image
        processing, social interaction, etc.].
      </li>
      <li>
        We reserve the right to change, suspend or terminate part or all of the services at any time according to actual circumstances, or update and optimize the service
        content. We will try our best to notify you in advance, but in some special cases, prior notice may not be possible.
      </li>
    </ol>

    <h2>2. Usage Specifications</h2>
    <ol>
      <li>
        <strong>Legal Use</strong>
        : You promise to use our products and services only for legal purposes and abide by all applicable laws and regulations. You shall not use our products and services to
        engage in any illegal or irregular activities, including but not limited to fraud, infringement, spreading malicious software, publishing obscene or violent content,
        etc.
      </li>
      <li>
        <strong>Account Security</strong>
        : If you need to register an account to use our products and services, you are responsible for properly keeping your account information and password. You shall not
        lend, rent or sell your account to others. If you find any abnormality or security problem with your account, please notify us immediately.
      </li>
      <li>
        <strong>Content Usage</strong>
        : All content (such as text, pictures, videos, etc.) uploaded, published or transmitted by you during the use of the products and services shall ensure that you have
        the legal right to use such content, and such content does not infringe upon any third party's intellectual property rights, privacy rights or other legal rights and
        interests. We have the right to review the content you upload, and if illegal content is found, we have the right to delete it or require you to modify it.
      </li>
    </ol>

    <h2>3. Intellectual Property Rights</h2>
    <ol>
      <li>
        All intellectual property rights contained in our products and services, such as software codes, trademarks, patents, copyrights, etc., are owned by us or we have
        obtained legal authorization for use. You only have the right to use these intellectual property rights within the scope permitted by these terms of use, and shall not
        arbitrarily copy, modify, spread, sell or engage in other infringing acts.
      </li>
      <li>
        The intellectual property rights of the content created by you in the process of using the products and services belong to you. However, you grant us a global, non -
        exclusive, sub - licensable and free license to allow us to use, copy, modify, display and spread your content within the necessary scope of providing services,
        promoting products, etc.
      </li>
    </ol>

    <h2>4. Limitation of Liability</h2>
    <ol>
      <li>
        We try our best to ensure the normal operation of products and services, but service interruptions, delays or errors may occur due to technical failures, network
        problems, force majeure and other reasons. We shall not be liable for any losses caused to you due to these reasons, but we will try our best to take measures to
        reduce the impact and restore the service in time.
      </li>
      <li>
        To the maximum extent permitted by law, we shall not be liable for any direct, indirect, incidental, special or consequential losses (including but not limited to data
        loss, business interruption, loss of profits, etc.) suffered by you due to the use of our products and services, unless such losses are caused by our intentional or
        gross negligence.
      </li>
    </ol>

    <h2>5. Privacy Policy</h2>
    <p>
      Your privacy is very important to us. For how we collect, use, store and protect your personal information, please refer to our privacy policy. The privacy policy is an
      important part of these terms of use and, together with these terms of use, constitutes the basis of the agreement for your use of our products and services.
    </p>

    <h2>6. Agreement Changes</h2>
    <p>
      We reserve the right to modify these terms of use at any time. The revised terms will be published on our official platform. Your continued use of our products and
      services after the change of the terms shall be deemed as your acceptance of the revised terms. If you do not agree with the revised terms, you can choose to stop using
      our products and services.
    </p>

    <h2>7. Dispute Resolution</h2>
    <p>
      If a dispute arises between you and us in the performance of these terms of use, it shall first be resolved through friendly negotiation. If negotiation fails, either
      party shall have the right to file a lawsuit with the people's court with jurisdiction.
    </p>
  </div>
</template>
<script>
import utils from '@/utils/index'
import config from '@/config/index'
export default {
  data() {
    return {
      activationCompany: {
        company: 'Dongguan Andao Optoelectronic Materials Manufacturing Co., LTD',
        address: 'Building A, Building 11, Zone C, Songshan Lake International Finance Park, Dongguan City, Guangdong Province',
        abbreviation: 'Andao'
      }
    }
  },
  created() {
    // this.activationCompany = config.companyList[0]
  },
  mounted() {
    const identify = utils.getParamByUrl('cType')
    if (identify) {
      this.activationCompany = config.companyList[identify]
    }
  },
  methods: {}
}
</script>
<style lang="scss" scoped>
h3 {
  font-size: 16px;
  text-align: center;
}

p {
  font-size: 14px;
  text-indent: 2em;
}
.underline {
  text-decoration: underline;
}
.primaryColor {
  color: #1e80ff;
}
</style>
